module.exports = __webpack_public_path__ + "img/offcan-logo.d858b0b0.svg";